import React, { useEffect, useState } from "react";
import { Container, Button,Form ,Modal} from "react-bootstrap";
import TableComponent from "../components/TableComponent";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { formatDate, formatActive } from "../utils/helpers";

import { useAuth } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

function UserList() {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

    const { user } = useAuth();
      ///////////////////////////
      const [showModal, setShowModal] = useState(false);
      const [password, setPassword] = useState(false);
      const [selectedId, setSelectedId] = useState(null);
      const [error, setError] = useState("");
      ////////////////////////////

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios.get(`${API_URL}/user_list`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setUsers(res.data.users || []))
      .catch(err => console.error(err));
  }, []);

  const handleEdit = (id) => navigate(`/UserEdit/${id}`);
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;
    const token = localStorage.getItem("token");
    try {
      const res = await axios.delete(`${API_URL}/user_delete/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.status) {
        setUsers(users.filter(u => u.id !== id));

        alert(res.data.message);
      }

      else { alert("Failed to delete"); }
    } catch (err) { console.error(err); }
  };

  const openPasswordModal = (literature_id) => {
    setSelectedId(literature_id);
    setPassword("");
    setError("");
    setShowModal(true);
  };


  const verifyPassword = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${API_URL}/verify-password`,
        { password, uid: user?.uid },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        setShowModal(false);

        handleDelete(selectedId);
      } else {
        setError("Incorrect password");
      }
    } catch (err) {
      setError("Incorrect password");
    }
  };


  const columns = [
    { key: "index", label: "Sr.no", format: (_, __, index) => index + 1 },
    { key: "username", label: "Username" },
    { key: "email", label: "Email" },
    { key: "active", label: "Active", format: formatActive },
    { key: "created_date", label: "Created Date", format: formatDate },
    {
      key: "action",
      label: "Action",
      format: (_, row) => (
        <>
          <Button size="sm" className="me-2" onClick={() => handleEdit(row.id)}>Edit</Button>
          <Button size="sm" variant="danger" onClick={() => openPasswordModal(row.id)}>Delete</Button>
        </>
      )
    }
  ];

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>User List</h3>
        <Link className="btn btn-primary" to="/register">Add User</Link>
      </div>

      <TableComponent columns={columns} data={users} rowsPerPage={10} maxHeight={400} />



                  <Modal
                      show={showModal}
                      onHide={() => setShowModal(false)}
                      centered
                      backdrop="static"
                      keyboard={false}
                      dialogClassName="soft-modal"
                  >
                      <Modal.Header closeButton style={{ borderBottom: "none" }}>
                          <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                              Confirm Password
                          </Modal.Title>
                      </Modal.Header>
      
                      <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                          <Form.Group>
                              <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                                  Enter your password
                              </Form.Label>
                              <Form.Control
                                  type="password"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  placeholder="" autoComplete="off"
                                  style={{
                                      borderRadius: "12px",
                                      border: "1px solid #ddd",
                                      padding: "10px 15px",
                                      fontSize: "0.95rem",
                                      boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                                  }}
                              />
                          </Form.Group>
                          {error && (
                              <p
                                  className="text-danger mt-2"
                                  style={{ fontSize: "0.9rem", fontWeight: 500 }}
                              >
                                  {error}
                              </p>
                          )}
                      </Modal.Body>
      
                      <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                          <Button
                              variant="outline-secondary"
                              onClick={() => setShowModal(false)}
                              style={{
                                  borderRadius: "10px",
                                  padding: "8px 18px",
                                  fontWeight: 500,
                                  boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                              }}
                          >
                              Cancel
                          </Button>
                          <Button
                              variant="primary"
                              onClick={verifyPassword}
                              style={{
                                  borderRadius: "10px",
                                  padding: "8px 20px",
                                  fontWeight: 600,
                                  background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                                  border: "none",
                                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                              }}
                          >
                              Verify
                          </Button>
                      </Modal.Footer>
                  </Modal>
    </Container>
  );
}

export default UserList;
